module.exports = __webpack_public_path__ + "static/media/tele6.cc84acd6.svg";